import { z } from "zod/v4";
import { insuranceNetworkValues } from "../InsuranceNetworks.js";
import { therapeuticMaterialCodeValues, therapeuticMaterialFamilyValues, } from "../materiaux.js";
const therapeuticMaterialFamilySchema = z.enum(therapeuticMaterialFamilyValues);
const therapeuticMaterialCodeSchema = z.enum(therapeuticMaterialCodeValues);
const insuranceNetworkSchema = z.enum(insuranceNetworkValues);
const familyDefaultEntrySchema = therapeuticMaterialCodeSchema.nullable();
export const defaultMaterialsByActKindSettingsSchema = z.object({
    defaultByFamily: z.partialRecord(therapeuticMaterialFamilySchema, familyDefaultEntrySchema),
    networkOverrides: z.partialRecord(insuranceNetworkSchema, z.partialRecord(therapeuticMaterialFamilySchema, familyDefaultEntrySchema)),
});
export const defaultMaterialsByActKindSaveInputSchema = defaultMaterialsByActKindSettingsSchema;
//# sourceMappingURL=DefaultMaterialsByActKindSchemas.js.map